import styled from 'styled-components'
export const TodoListWrapper = styled.div`
  height: 100%;
  overflow-y: hidden;
  display: flex;
  flex-flow: column;
`

export const HeaderWrapper = styled.div`
  background-color: white;
  padding: 0 0;
  flex: 0 1 auto;
`
// export const CreateBtnWrapper = styled.div`
// 	padding: 0 calc(100vw * (20 / 375));
// `;
export const BodyWrapper = styled.div`
  position: relative;
  padding: calc(100vw * (24 / 375)) calc(100vw * (17 / 375)) calc(100vw * (70 / 375));
  flex: 1 1 auto;
  height: 100%;
  overflow-y: scroll;
`

export const BodyInfoSection = styled.div`
  display: flex;
  flex-flow: column;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
`
export const InfoIconWrapper = styled.div`
  width: calc(100vw * (69 / 375));
  height: calc(100vw * (87 / 375));
  margin-bottom: calc(100vw * (8 / 375));
`
export const InfoIcon = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`
export const InfoTxt = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: calc(100vw * (14 / 375));
  /* or 19px */

  display: flex;
  align-items: center;
  text-align: center;

  color: #7f7f7f;
`
// export const CreateTodoListBtn = styled.div`
// 	display: flex;
// 	background: #ECECEC;
// 	border-radius: 12px;
// 	padding: calc(100vw * (15 / 375));
// 	margin-bottom: calc(100vw * (11 / 375));
// 	justify-content: center;
// 	align-items: center;
// `;

// export const TodoListPlusIcon = styled.span`
// 	line-height: calc(100vw * (20 / 375));
//     color: #BCBDBF;
//     display: inline-block;
//     width: calc(100vw * (16 / 375));
//     height: calc(100vw * (16 / 375));
//     margin-right:calc(100vw * (11 / 375))
// `;
// export const CreateTodoListTxt = styled.span`
// 	font-size: calc(100vw * (14 / 375));
// 	line-height: calc(100vw * (20 / 375));
// 	color: #BCBDBF;
// `;
export const ImgFileInput = styled.input`
  display: none;
`

export const FullScreen = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 400;
`

export const EmptyContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const EmptyContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const EmptyImg = styled.img`
  width: calc(100vw * (78 / 375));
  height: calc(100vw * (90 / 375));
  position: relative;
  left: calc(100vw * (-14 / 375));
  margin-bottom: calc(100vw * (11 / 375));
`

export const EmptyDesc = styled.div`
  font-weight: 500;
  font-size: calc(100vw * (16 / 375));
  line-height: calc(100vw * (24 / 375));
  text-align: center;
  color: #7f7f7f;
  margin-bottom: calc(100vw * (21 / 375));
`

export const EmptyActionBtn = styled.button`
  background: #ffcf19;
  border-radius: calc(100vw * (10 / 375));
  padding: calc(100vw * (13 / 375)) calc(100vw * (22 / 375));
  font-weight: 500;
  font-size: calc(100vw * (14 / 375));
  line-height: calc(100vw * (23 / 375));
  text-align: center;
  color: #000000;
`
